<template>
  <div class="container">
    <Search :searchParams="searchParams" @searchFn="searchFn" />

    <Empty v-if="finished && list.length <= 0" />
    <div class="list" v-else>
      <van-list
        :loading="loading"
        :finished="finished"
        :error="error"
        finished-text="没有更多了"
        error-text="请求失败"
        :immediate-check='false'
        @load="getData"
      >
        <Item
          v-for="(item, index) in list"
          :key="index"
          :itemData="item" />
      </van-list>
    </div>
  </div>
</template>

<script>
import Search from '@/components/search.vue';
import Item from '@/components/hospital/item.vue';
import Empty from '@/components/empty.vue';
import { getHospitalList, getNewHospitalList } from '@/api/hospital';

export default {
  components: {
    Search,
    Item,
    Empty,
  },
  data() {
    return {
      searchParams: {
        readOnly: false,
        placeholder: '请输入医院名称',
        query: '',
        focus: true,
      },
      loading: false,
      finished: false,
      error: false,
      list: [],
      pageSize: 30,
      currentPage: 1,
    };
  },
  computed: {
    // 渠道名称
    channelString() {
      return this.$route.query.channelString || '';
    },
    // 店铺ID
    shopId() {
      return this.$route.query.shopId || '';
    },
    // 是否使用新接口的渠道
    isNewApiChannel() {
      const newApiChannels = ['双山小程序医保', '广钢小程序粤医保', '梧州小程序医保'];
      return newApiChannels.includes(this.channelString);
    },
  },
  mounted() {
    this.searchParams.query = this.$route.query.name || '';
    this.getData();
  },
  methods: {
    getData(refreshing) {
      if (this.loading) return;
      this.loading = true;

      if (refreshing) {
        this.finished = false;
        this.currentPage = 1;
        this.list = [];
      }

      if (this.finished) return;

      // 根据渠道选择不同的接口
      const apiMethod = this.isNewApiChannel ? getNewHospitalList : getHospitalList;
      let params = {};

      if (this.isNewApiChannel) {
        // 新接口参数：name, pageNo, pageSize, shopId
        params = {
          name: this.searchParams?.query || '',
          pageNo: this.currentPage,
          pageSize: this.pageSize,
          shopId: this.shopId,
        };
      } else {
        // 旧接口参数：name, currentPage, pageSize
        params = {
          name: this.searchParams?.query || '',
          currentPage: this.currentPage,
          pageSize: this.pageSize,
        };
      }

      apiMethod(params).then((res) => {
        if (res && res.code === 200) {
          // 兼容新旧数据格式
          let records = [];
          let total = 0;

          if (this.isNewApiChannel) {
            // 新接口格式：data: {totalCount, totalPage, content}
            records = res.data.content || [];
            total = res.data.totalCount || 0;
          } else {
            // 旧接口格式：data: {records, total}
            records = res.data.records || [];
            total = res.data.total || 0;
          }

          this.list = [...this.list, ...records];
          this.loading = false;

          // 判断是否加载完毕
          if (total <= this.list.length) {
            this.finished = true;
          } else {
            this.currentPage += 1;
          }
        } else {
          this.error = true;
          this.loading = false;
          this.finished = false;
        }
      });
    },
    searchFn(val) {
      this.searchParams.query = val;
      console.log(val);
      this.getData(true);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: calc(100vh - 44px);
  overflow: auto;
  background: white;
}

.list {
  margin-top: 52px;
}

.van-pull-refresh {
  overflow: auto;
}
</style>
